import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { sortVariantFieldsByRank } from "../../../common/util";
import { IMG_PLACEHOLDER, STORAGE_BUCKET } from "../../../common/constants";
import HTMLViewer from "../../../common/component/HTMLViewer";

export default function OrderPrintLineItems(props) {
  const { items, type } = props;

  return (
    <Box my={1}>
      {type === "compact" && (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={1}>
              <Typography color="textSecondary" variant="overline">
                QTY
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography color="textSecondary" variant="overline">
                ITEM
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="textSecondary" variant="overline"></Typography>
            </Grid>
          </Grid>
        </Box>
      )}
      {items &&
        items.map((item, idx) => {
          return (
            <Box key={idx} mt={1}>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={1}>
                    <Box
                      sx={{
                        width: "28px",
                        height: "28px",
                        border: "1px solid #DDD",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h6">{item.quantity} </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography variant="h6">{item.title}</Typography>
                    <Box>
                      <Box>
                        {item.variant &&
                          Object.entries(item.variant)
                            .sort(([k1, v1], [k2, v2]) =>
                              sortVariantFieldsByRank({ key: k1, ...v1 }, { key: k2, ...v2 })
                            )
                            .map(([key, value]) => {
                              const fieldName = (value.field?.name || key).toUpperCase();

                              if (type === "compact") {
                                return (
                                  <Box>
                                    <Typography
                                      variant="body1"
                                      display="inline"
                                      color="textSecondary"
                                    >
                                      {`[${fieldName}]: `}
                                    </Typography>
                                    <Typography variant="body1" display="inline">
                                      {`${value?.name}   •   `}
                                    </Typography>
                                  </Box>
                                );
                              } else {
                                return (
                                  <Box>
                                    <Typography variant="overline" color="textSecondary">
                                      {fieldName}
                                    </Typography>
                                    <Typography variant="body1">{value?.name}</Typography>
                                  </Box>
                                );
                              }
                            })}
                        {item.customization?.inscription?.text && (
                          <Typography variant="body1" gutterBottom>
                            Inscription: {item.customization.inscription?.text}
                          </Typography>
                        )}
                        {item.tags &&
                          (type === "compact" ? (
                            <Box>
                              <Typography
                                variant="body1"
                                display="inline"
                                color="textSecondary"
                              >
                                {`[TAGS]: `}
                              </Typography>
                              <Typography variant="body1" display="inline">
                                {`${item.tags?.join(", ")}   •   `}
                              </Typography>
                            </Box>
                          ) : (
                            <Box>
                              <Typography variant="overline" color="textSecondary">
                                TAGS
                              </Typography>
                              <Typography variant="body1">{item.tags?.join(", ")}</Typography>
                            </Box>
                          ))}
                        {item.description &&
                          (type === "compact" ? (
                            <Box>
                              <Typography
                                variant="body1"
                                display="inline"
                                color="textSecondary"
                              >
                                {`[NOTES]: `}
                              </Typography>
                              <Box component="span" sx={{ display: "inline" }}>
                                <HTMLViewer
                                  content={item.description}
                                  style={{ display: "inline", fontSize: "1rem" }}
                                />
                              </Box>
                              <Typography variant="body1" display="inline">
                                {`   •   `}
                              </Typography>
                            </Box>
                          ) : (
                            <Box>
                              <Typography variant="overline" color="textSecondary">
                                NOTES
                              </Typography>
                              <HTMLViewer content={item.description} />
                            </Box>
                          ))}
                      </Box>
                    </Box>
                  </Grid>
                  {type === "compact" && (
                    <Grid item xs={2} align="right">
                      <img
                        src={item.images[0] || `${STORAGE_BUCKET}${IMG_PLACEHOLDER}`}
                        style={{ height: "100px", objectFit: "contain" }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Box>
          );
        })}
    </Box>
  );
}
